import { Box, Chip, Divider, styled } from "@mui/material";

import CategoryBox from "../../components/CategoryBox";
import DatePickerButton from "./DatePickerButton";
import FiltersModal from "./FiltersModal";
import LectureCard from "../../components/LectureCard";
import LectureListContext from "../../contexts/LectureListContext";
import { selectAllAreas } from "../../stores/areas/areasSelectors";
import { selectAllInstructors } from "../../stores/instructors/instructorsSelectors";
import { selectAllLectures } from "../../stores/lectures/lecturesSelectors";
import { selectAllTopics } from "../../stores/topics/topicsSelectors";
import { useContext } from "react";
import { useSelector } from "../../stores";

const Home = () => {
    const {
        topicIds,
        setTopicIds,
        areaIds,
        setAreaIds,
        instructorIds,
        setInstructorIds,
        hasVideo,
        setHasVideo,
    } = useContext(LectureListContext);

    const topics = useSelector(selectAllTopics) || [];
    const lectures = useSelector(selectAllLectures) || [];
    const filteredLectures = lectures.filter((lecture) => {
        if (hasVideo === null || hasVideo === undefined) return true;
        const present = Boolean(lecture?.videoLink);
        return hasVideo ? present : !present;
    });
    // const lecturesLoading = useSelector(selectLectureLoading);
    const areas = useSelector(selectAllAreas) || [];
    const instructors = useSelector(selectAllInstructors) || [];

    const areaChips = areas
        .filter((area) => area?.id && areaIds.includes(Number(area.id)))
        .map((area) => (
            <Chip
                key={area.id}
                sx={{
                    backgroundColor: "#d3d3d3",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                }}
                label={area?.name || ""}
                onDelete={() =>
                    setAreaIds(areaIds.filter((areaId) => area.id !== areaId))
                }
            />
        ));

    const instructorChips = instructors
        .filter((instructor) => instructor?.id && instructorIds.includes(Number(instructor.id)))
        .map((instructor) => (
            <Chip
                key={instructor.id}
                sx={{
                    backgroundColor: "#d3d3d3",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "10px",
                }}
                label={instructor?.fullName || ""}
                onDelete={() =>
                    setInstructorIds(
                        instructorIds.filter(
                            (instructorId) => instructor.id !== instructorId
                        )
                    )
                }
            />
        ));

    return (
        <PageWrapper>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="center"
                height="100%"
                paddingTop={5}
                paddingBottom={15}
                rowGap={2}
            >
                {/* Topics Section */}
                <Box
                    display="flex"
                    alignItems="flex-end"
                    flexDirection="column"
                    gap={1}
                    width="95%"
                >
                    {/* <Typography variant="h5"> المواضيع</Typography> */}
                    <Box
                        display="flex"
                        gap={1}
                        sx={{
                            overflowX: "scroll",
                            width: "100%",
                            "&::-webkit-scrollbar": { display: "none" },
                            scrollbarWidth: "none",
                        }}
                        padding={0.5}
                    >
                        {topics.map((topic) => (
                            <CategoryBox
                                key={topic?.id || Math.random()}
                                topic={topic}
                                selected={topic?.id ? topicIds.includes(Number(topic.id)) : false}
                                onClick={() => {
                                    if (topic?.id) {
                                        if (topicIds.includes(Number(topic.id))) {
                                            setTopicIds([]);
                                        } else {
                                            setTopicIds([Number(topic.id)]);
                                        }
                                    }
                                }}
                            />
                        ))}
                    </Box>
                </Box>

                <Divider
                    sx={{ borderWidth: 1, width: "95%", borderColor: "black" }}
                />

                <Box width="95%" display="flex" gap={1}>
                    <DatePickerButton />

                    <FiltersModal />
                </Box>

                <Box width="90%" display="flex" gap={1} flexWrap="wrap">
                    {instructorChips}

                    {areaChips}

                    {(hasVideo === true || hasVideo === false) && (
                        <Chip
                            sx={{
                                backgroundColor: "#d3d3d3",
                                height: "32px",
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "10px",
                            }}
                            label={hasVideo ? "يوجد فيديو" : "لا يوجد فيديو"}
                            onDelete={() => setHasVideo(null)}
                        />
                    )}
                </Box>

                {/* Lectures Section */}
                <Box
                    display="flex"
                    justifyContent="center"
                    flexDirection="column"
                    gap={1}
                    width="95%"
                >
                    {/* <Typography variant="h4" textAlign="right">
                        قادم هذا الأسبوع
                    </Typography> */}

                    <Box
                        display="flex"
                        flexDirection="column"
                        gap={1}
                        width="100%"
                        overflow="auto"
                    >
                        {filteredLectures.map((lecture) => (
                            <LectureCard key={lecture.id} lecture={lecture} />
                        ))}
                    </Box>
                </Box>
            </Box>

        
        </PageWrapper>
    );
};

export default Home;

const PageWrapper = styled(Box)({
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundImage: "url(/assets/tawhadi_background.png)",
    backgroundSize: "auto",
    backgroundPosition: "center",
    backgroundRepeat: "repeat",
});
